import script from "./AdministratorProjectFormStep8.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectFormStep8.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectFormStep8.vue?vue&type=style&index=0&id=e3e3ec3e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3e3ec3e"]])

export default __exports__